// radio-group.tsx
import { useEffect, useState } from 'react';
import { classNames } from '../../utils';

export const RadioGroupSpecial = ({
  name,
  label,
  value,
  items,
  onChange,
  hor = false
}: {
  name: string;
  label?: string;
  value: string | number;
  items: { id: string | number; label: string }[];
  hor?: boolean;
  onChange: (item: { [key: string]: string | number }) => void;
}) => {
  const [selected, setSelected] = useState(value);

  const handleChange = (value: string | number) => {
    setSelected(value);
    onChange({ [name]: value });
  };

  useEffect(() => {
    setSelected(value);
  }, [value]);



  return (
    <fieldset className="mb-[24px] space-y-[8px] w-full">
      {label && (
        <legend className="block text-sm font-semibold leading-6 text-gray-700 mb-[20px]">
          {label}
        </legend>
      )}
      <div className={classNames(hor ? 'flex gap-x-6' : 'space-y-[24px]')}>
        {items.map((item) => (
          <label key={item.id} className="relative flex items-center cursor-pointer">
            <input
              type="radio"
              name={name}
              id={`${item.id}-${name}`}
              checked={selected === item.id}
              onChange={() => handleChange(item.id)}
              className="focus:ring-transparent h-4 w-4 text-gray-darker border-gray-dark"
            />
            <span className="ml-2 text-sm">{item.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};
